import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import UserSessionContext from 'context/UserSessionContext';
import LoadingSpinner from 'components/LoadingSpinner';

function AdminRoute({ component: Component, ...rest }) {
  const { session } = useContext(UserSessionContext);
  const { isUserStateLoading, isLoggedIn, isAdmin } = session;

  if (isUserStateLoading) {
    return <LoadingSpinner />;
  }

  if (!isLoggedIn) {
    return <Redirect to="/login" />;
  }

  return (
    <Route
      {...rest}
      render={props => {
        if (isAdmin) {
          return <Component {...props} />;
        }
        return <Redirect to="/" />;
      }}
    />
  );
}
AdminRoute.propTypes = {
  component: PropTypes.elementType
};

AdminRoute.defaultProps = {
  component: null
};

export default AdminRoute;
